import { ArticleHeading5, ArticleParagraph2, useDeviceType } from '@cian/ui-kit';
import * as style from './styles.css';
import { clsx } from 'clsx';

export const DiscountBanner: React.FC = () => {
  const device = useDeviceType();

  const Description = device === 'phone' ? ArticleParagraph2 : ArticleHeading5;

  return (
    <div className={clsx(style['container'], style[device])}>
      <div className={style['text-block']}>
        <div className={style['title']}>Подключите скидку на&nbsp;ипотеку</div>
        <Description color="white_100" fontWeight="400">
          Продайте квартиру во вторичке быстрее со&nbsp;сниженной ставкой
        </Description>
      </div>
      <div className={style['image']} />
    </div>
  );
};
